module.exports = __webpack_public_path__ + "img/杭州密码子.ff8eafad.png";